import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

const Navigation = ({ items, onClick }) => {
    return (
        items.length > 0 && (
            <div className={styles.list}>
                {items.map(({ active, content, id }) => (
                    <button
                        type="button"
                        key={id}
                        className={cn(styles.list__item, {
                            [styles["list__item--active"]]: active,
                        })}
                        onClick={onClick(id)}
                    >
                        {content}
                    </button>
                ))}
            </div>
        )
    );
};

export default Navigation;
